var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"rounded-sm shadow-sm",staticStyle:{"min-height":"150px","background-color":"#f8f8f8"}}),_c('h1',[_vm._v("Test Hear")]),_c('b-icon',{attrs:{"icon":"check"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }